import axios from 'axios';

const BASE_URL = '/api/preguntas-frecuentes';

export const fqasEditService = {
  editFQA: async (empresaId, idVector, idColeccion, data) => {
    // idVector es el ID de la pregunta (mapped as id_vector by service)
    // data: { tipo, tema, pregunta, respuesta }
    try {
      const response = await axios.patch(`${BASE_URL}/edit/${idVector}`, data);
      return response.data;
    } catch (error) {
      console.error('Error editing FAQ:', error);
      throw error;
    }
  }
};
